import Cookies from "js-cookie";
import { useContext, useState } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { error } from "../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../components/buttons/Button";
import CEmailField from "../../../../components/inputBoxes/email-input";
import CPassword from "../../../../components/inputBoxes/password-input";
import { LoadingContext } from "../../../../context/loadingContext";
import { SignInFormHooks } from "../hooks/useLogin";
import EmailVerification from "./EmailVerification";

const SignInForm = (props) => {
  const { setLoading } = useContext(LoadingContext);
  let navigate = useNavigate();
  const [FieldValues, setFieldValues] = useState();
  const [forgotPwd, setForgotPwd] = useState(false);

  // User login using SignInFormHooks

  const signInHandle = async () => {
    setLoading(true);
    const result = await SignInFormHooks(FieldValues);
    if (result.authorized) {
      setLoading(false);
      props.setLogin(true);
      navigate("/dashboard");
    } else if (!result.authorized) {
      setLoading(false);
      if (result.state === 1) {
        navigate("/otp");
      } else if (result.state === 2) {
        Cookies.set("portal_id", result.portal_id);
        navigate(
          "/registration/" + result.portal_id
        );
      } else {
        error(result.message);
      }
    }
  };
  const HandleFieldValues = (key, value) => {
    setFieldValues({ ...FieldValues, [key]: value });
  };
  return (
    <>
      <div className="bg-img">
        <div className="container">
          <div className="row m-0">
            <div className="col-md-6 col-sm-12"></div>
            <div className="col-md-6 col-sm-12">
              <Card
                className="py-5 border border-0 rounded-0"
                style={{ minHeight: "100vh" }}
              >
                <div className="container mb-5">
                  <div className="row">
                    <div className="col-2"></div>
                    <div className="col-md-8 col-sm-12">
                      <Card.Body>
                        {forgotPwd === false ? (
                          <>
                            <Card.Title
                              className="text-center mb-4 mt-3"
                              style={{ color: "#044389" }}
                            >
                              <h4 className="fw-bolder">Sign In</h4>
                            </Card.Title>
                            <CEmailField
                              customClassDiv={"mb-4"}
                              customClassInput={"bg-primary-soft"}
                              labelName={"Email"}
                              name={"email"}
                              placeholder={"12345678@gmail.com"}
                              customClassLabel={"text-primary-new"}
                              functionName={(name, email) =>
                                HandleFieldValues(name, email)
                              }
                            />
                            <CPassword
                              labelName={"Password"}
                              customClassInput={"bg-primary-soft"}
                              placeholder={"Enter your password"}
                              customClassLabel={"text-primary-new"}
                              name={"password"}
                              functionName={(name, value) =>
                                HandleFieldValues(name, value)
                              }
                            />
                            <CButton
                              btnClasses={
                                "btn bg-transparent text-primary border-0 text-decoration-underline"
                              }
                              IsOutline={false}
                              innertext={"Forgot password"}
                              btnCustomStyle={{
                                backgroundColor: "#044389",
                                fontSize: "14px",
                              }}
                              functionName={() => setForgotPwd(true)}
                            />
                            <CButton
                              btnClassesDiv={"text-center mt-4"}
                              btnClasses={"btn px-4 fw-bold text-white"}
                              IsOutline={false}
                              innertext={"Login"}
                              btnCustomStyle={{
                                backgroundColor: "#044389",
                              }}
                              functionName={() => signInHandle()}
                            />
                          </>
                        ) : (
                          <EmailVerification />
                        )}
                      </Card.Body>
                    </div>
                    <div className="col-2"></div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignInForm;
